import pubsub from "@viewlift/pubsub"
function subscribeRenderUpdatedTimer(cb) {
    pubsub.subscribe('render-updated-timer',cb)
}
function publishRenderUpdatedTimer(data) {
    pubsub.publish('render-updated-timer',data)
}
function unsubscribeRenderUpdatedTimer(cb) {
    pubsub.subscribe('render-updated-timer',cb)
}
export {subscribeRenderUpdatedTimer,publishRenderUpdatedTimer,unsubscribeRenderUpdatedTimer}